import { createAction, props } from '@ngrx/store';
import { ResponsePasswordCreate, RequestPasswordCreate } from '../../shared/interfaces';
import { PasswordCreateTypes } from '../../shared/enums';

export const getPasswordCreate = createAction(
    PasswordCreateTypes.PASSWORD_CREATE,
    props<{ request: RequestPasswordCreate}>()
);

export const getPasswordCreateSucess = createAction(
    PasswordCreateTypes.PASSWORD_CREATE_SUCCESS,
    props<{ response: ResponsePasswordCreate }>()
);

export const getPasswordCreateError = createAction(
    PasswordCreateTypes.PASSWORD_CREATE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    PasswordCreateTypes.CLEAN_STATE
);

